var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.8691 9.00011C21.0837 9.00011 14.543 -2.32871 8.93345 7.38359C14.5386 -2.32871 1.45705 -2.32871 7.06655 7.38359C1.46144 -2.32871 -5.07932 9.00011 6.1309 9.00011C-5.08371 9.00011 1.45705 20.3289 7.06655 10.6166C1.46144 20.3289 14.543 20.3289 8.93345 10.6166C14.5386 20.3333 21.0793 9.00011 9.8691 9.00011Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerGray);
export default __webpack_public_path__ + "static/media/flower_gray.fafd6ff55df04b73cc9ca97ab0fb82b0.svg";
export { ForwardRef as ReactComponent };